import styled from "styled-components";
import { Link } from "react-router-dom";
import { Row, Container } from "reactstrap";
import {
  FontNunitoBold,
  FontNunitoLight,
  FontNunitoRegular,
  FontNunitoSemiBold
} from "../../../reusablestyled";

const isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(
    !window["safari"] ||
    (typeof safari !== "undefined" && window["safari"].pushNotification)
  );

const checkPathToDisplaySecretSantaEventForNavbar = (params, location) => {
  if (
    location === "/" ||
    location === "/sneakers" ||
    location === "/streetwear" ||
    location === "/fashion" ||
    location === "/apparel" ||
    location === "/luxury" ||
    location === "/lifestyle" ||
    location === "/toys" ||
    location === "/electronics-collectibles" ||
    location === "/bcaxkickavenue"
  ) {
    return params ? "18rem" : "12.5rem"
  } else {
    return "12.5rem"
  }
};

const KickNavbarV3Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #4a4a4a;
  margin-bottom: ${(props) => checkPathToDisplaySecretSantaEventForNavbar(props.countdown, props.locationName)};
  &.navbar-inner-kickave-desktop__no-navbar-category {
    margin-bottom: 8.5rem;
  }
  @media only screen and (max-device-width: 576px) {
    display: none;
  }
`;

const KickNavbarV3Overlay = styled.div`
  display: ${(props) => (props.isHide ? "none" : "block")};
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: transparent;
  cursor: pointer;
  @media only screen and (max-device-width: 576px) {
    display: none;
  }
`;

const A = styled.a`
  display: flex !important;
  justify-content: center;
  align-items: center;
  margin-right: 0rem !important;
`;

const Anchor = styled.a`
  color: ${(props) => (props.primary ? "#159953" : "#4a4a4a")};
  border: ${(props) => (props.link ? "none" : ".5px solid #4a4a4a")};
  border-radius: 2px;
  padding: ${(props) => (props.withPadding ? ".75rem 2rem" : "7px 15px")};
  font-size: 0.75rem;
  font-family: ${FontNunitoSemiBold};
  text-decoration: ${(props) => (props.link ? "underline" : "none")};
  &:hover {
    background-color: ${(props) => (props.link ? "none" : "#159953")};
    border: ${(props) => (props.link ? "none" : ".5px solid #159953")};
    color: ${(props) =>
    props.link ? (props.primary ? "#159953" : "#4a4a4a") : "#FFF"};
    text-decoration: ${(props) => (props.link ? "underline" : "none")};
  }
  &.btn-payment {
    margin-left: 9%;
  }
  &.btn-login {
    margin-left: 5%;
  }
  &.btn-sell-request {
    margin-left: 5%;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
    font-size: 0.5625rem;
    padding: 0.75rem 1rem;
  }
`;

const LinkTo = styled(Link)`
  color: ${(props) => (props.primary ? "#159953" : "#4a4a4a")}; 
  border: ${(props) => (props.link ? "none" : ".5px solid #4a4a4a")};
  border-radius: 2px;
  ${"" /* padding: 7px 15px; */}
  padding: ${(props) => (props.link ? ".75rem 0 .75rem 2rem" : ".75rem 2rem")};
  font-size: 0.75rem;
  font-family: ${FontNunitoSemiBold};
  text-decoration: ${(props) => (props.link ? "underline" : "none")};
  &:hover{
    background-color: ${(props) => (props.link ? "none" : "#159953")};
    border: ${(props) => (props.link ? "none" : ".5px solid #159953")};
    color: ${(props) =>
    props.link ? (props.primary ? "#159953" : "#4a4a4a") : "#FFF"};
    text-decoration: ${(props) => (props.link ? "underline" : "none")};
  }
  &.btn-payment{
    margin-left: 9%;
  }
  ${"" /* &.btn-login{
    margin-left: 5%
  } */}
  &.btn-sell-request{
    margin-left: 5%
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1){
    font-size: 0.5625rem;
    padding: .75rem 1rem;
  }
`;

const KickNavbarV3WrapperInner = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  background: #fff;
`;

// const KickNavbarV3WrapperInnerTop = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: row;
//   width: 100%;
//   background: #fff;
// `;
const KickNavbarV3WrapperInnerTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background: #fff;
`;

let CountDownSecretSanta = styled.div`
  display: grid;
  grid-template-columns: 22fr 2fr;
  width: 100%;
  background-color: #242424;
  color: #ffffff;
  font-family: ${FontNunitoRegular};
  .left-mid-content-wrapper {
    width: 100%;
    height: auto;
    display: grid;
    cursor: pointer;
    grid-template-columns: ${isSafari ? "2fr 8fr" : "2fr 10fr"};
    padding: 8px;
    p {
      margin-bottom: 0px;
      font-family: "Nunito-Regular";
      span {
        ${'' /* font-family: "Nunito-Bold"; */}
      }
      .countdown-bold {
        font-family: "Nunito-Bold";
      }
    }
  }
  @media (max-width: 768px) {
    grid-template-columns: 6fr 1fr;
    padding: 8px;
    font-size: 10px;
    text-align: center;
    .left-mid-content-wrapper {
      padding: 0;
      grid-template-columns: 2fr 10fr;
      p {
        margin-bottom: 0;
        font-size: 12px;
        line-height: 1.5;
      }
    }
    p {
      margin-bottom: 0;
    }
  }
`;

let SecretSantaLeft = styled.div`
  line-height: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  align-items: start;
  p {
    &:first-child {
      color: #ffffff;
      font-family: ${FontNunitoSemiBold};
    }
  }
  @media (max-width: 480px) {
    justify-self: flex-start;
    align-items: self-start;
    line-height: 15px;
  }
`;
let SecretSantaMid = styled.div`
  line-height: 10px;
  justify-self: center;
  display: flex;
  justify-content: center;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  @media (max-width: 480px) {
    line-height: 13px;
  }
`;
let SecretSantaRight = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  width: auto;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  @media (max-width: 768px){
    padding: 12px;
  }
  img {
    cursor: pointer;
    z-index: 9;
    width: 12px;
    height: 12px;
    object-fit: contain;
    margin-right: 6px;
    @media (max-width: 768px){
      margin-right: 0px;
    }
  }
  @media (max-width: 480px) {
    img {
      width: 8.7px;
      height: 8.7px;
    }
  }
`;

const KickNavbarV3WrapperInnerBottom = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  background: #fff;
  ${"" /* padding: 0.1rem 1rem; */}
  border-top: .5px solid #4a4a4a;
  border-bottom: 0.5px solid #4a4a4a;
  &.container-category-kickave__desktop-hidden {
    display: none;
  }
`;

const InnerBottomUL = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 36px;
  text-align: center;
  -webkit-transition: 0.1s ease;
  transition: 0.1s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const InnerBottomItemA = styled.a`
  padding: 1rem;
  position: relative;
  line-height: 35px;
  text-align: center;
  vertical-align: top;
  text-decoration: none;
  color: ${(props) => (props.isHover ? "#179953 !important" : "#4a4a4a")};
  transform: ${(props) => (props.isHover ? "scale(2.2);" : "scale(1.0);")};
  font-family: ${(props) =>
    props.isHover ? FontNunitoSemiBold : FontNunitoRegular};
  padding: 0px;
  &:hover {
    transition: color 13s, font-size 13s;
    color: #179953;
    transition: all 0.2s;
    text-decoration: none;
    font-family: ${FontNunitoSemiBold};
  }
`;

const InnerBottomLI = styled.li`
  height: 100%;
  display: inline-block;
  ${"" /* margin-left: 35px; */}
  -webkit-transition: .2s ease;
  transition: .2s ease;
  ${"" /* padding: 0rem 3rem; */}
  flex: 1;
  
  ${"" /* float: left;  */}
  color: ${(props) => (props.isHover ? "#179953" : "#4a4a4a")};
  &:hover {
    ${InnerBottomItemA} {
      transition: color 15s, font-size 15s !important;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      -ms-transition: all 0.3s ease;
      cursor: pointer;
      color: ${(props) => (props.isHover ? "#179953" : "#4a4a4a")};
    } 
  }
  &:first-child{
    margin-left: 0;
  }​
`;

const InnerBottomBCA = styled.li`
  height: 100%;
  display: inline-block;
  ${"" /* margin-left: 35px; */}
  -webkit-transition: .2s ease;
  transition: .2s ease;
  ${"" /* padding: 0rem 3rem; */}
  flex: 1;
  
  ${"" /* float: left;  */}
  color: ${(props) => (props.isHover ? "#179953" : "#4a4a4a")};
  position: relative;
  &:hover {
    ${InnerBottomItemA} {
      transition: color 15s, font-size 15s !important;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      -ms-transition: all 0.3s ease;
      color: ${(props) => (props.isHover ? "#179953" : "#4a4a4a")};
    } 
  }
  &:first-child{
    margin-left: 0;
  }
  &:before {
    position: absolute;
    content: '';
    top: 0; 
    right: 0;
    border-bottom: 40px solid white;
    border-left: 10px solid #0b5ca9;
    width: 0;​
`;

const KickAvenueWrappIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: url("icon.jpg") no-repeat;
  ${"" /* cursor: pointer; */}
  /* padding-left: 3rem; */
  @media only screen and (max-width : 1024px) {
    padding-left: 1rem;
  }
  @media only screen and (max-width: 768px) {
    padding-left: 0;
  }
`;

const KickAvenueBrandIcon = styled.img`
  ${"" /* width: 120px; */}
  width: 100px;
  ${"" /* height: 90%; //Additional */}
  text-align: center;
`;

const KickAvenueBrand = styled(Link)`
  display: flex;
  margin: 0;
  align-items: center;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
`;

const SearchFormWrapper = styled.div`
  background-color: #4a4a4a;
  .form-control{
    height: 40px;
    border-radius: 0;
    width: 500px;
    /* width: 795px; */
    /* padding-left: 2rem; */
    padding-left: 3rem;
    font-size: .75rem;
    border: 1px solid #979797;
    &:focus{
      border-color: #979797;
      box-shadow: 0 0 0 0 #979797;
    }
  }
  img{
    position: absolute; 
    top: 25px; 
    width: 20px; 
    /* margin-left: .5rem; */
    margin-left: 1rem;
  }
  .search__result__container {
    color: #FFF;
    text-align: left;
    position: fixed;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-box-shadow: 0 4px 3px 0 hsla(0,0%,72.2%,.6);
    box-shadow: 0 4px 3px 0 hsla(0,0%,72.2%,.6);
    width: 500px;
    /* width: 795px; */
    z-index: 1050;
    background: #fff;
    border-left: 1px solid #979797;
    border-right: 1px solid #979797;
    border-bottom: 1px solid #979797;
    .search__result__inner{
      display: -webkit-box;
      display: -ms-flexbox;
      display: block;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      padding: 16px;
      border-right: 8px solid transparent;
      /* border-bottom: 1px solid #ddd; */
      text-transform: none;
      -webkit-transition: all .2s;
      transition: all .2s;
      color: #4a4a4a;
      min-height: 50px;
      max-height: 360px;
      .product_categories {
        .product_categories__item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: -16px;
          margin-right: -25px;
          padding-left: 16px;
          height: 60px;
          &:first-child{
            margin-top: -16px;
          }
          span{
            font-family: ${FontNunitoLight};
            bold {
              text-transform: capitalize;
              font-family: ${FontNunitoBold};
            }
          }
          &:hover{
            background-color: #ebecec;
          }
        }
      }
      .popular_searches {
        cursor: default;
        ${"" /* margin-top: 1rem; */}
        .popular__title {
          ${"" /* margin-top: 30px; */}
          font-size: 12px;
          color: #4a4a4a;
          letter-spacing: 1px;
          ${"" /* font-family: ${FontNunitoRegular}; */}
          p {
            margin:0;
          }
        }
        .popular_button_container {
          margin: 10px 0 10px 0;
          button {
            text-decoration: none;
            background-color: white;
            display: inline-block;
            border: 1px solid #fff;
            padding: 3px 8px;
            border-radius: 3px;
            margin-right: 10px;
            margin-top: 10px;
            ${"" /* max-width: auto; */}
            height: 38px;
            ${"" /* font-family: ${FontNunitoRegular}; */}
            color: #4a4a4a;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 1px;
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
            &:last-child { margin-right: 0 !important}
            &:hover{outline:0; background-color: #4a4a4a; color:#FFF;}
            &:focus{outline:0; background-color: #4a4a4a; color:#FFF;}
          }
        }
        .seller_wrap_result_search_content{
          cursor: pointer;
        }
      }
      .recent-search{
        .recent-search-title{
          cursor: default;
          span{
            font-family: ${FontNunitoLight};
            font-size: 12px;
            color: #4a4a4a;
            letter-spacing: 1px;
          }
        }
        .row{
          margin-top: 30px;
          .col-md-6{
            margin-bottom: 30px;
            span{
              cursor: pointer;
              color: #4a4a4a;
              font-size: 12px;
              font-weight: 600;
              letter-spacing: 1px;
              &:hover{
                ${"" /* font-size: 13px; */}
                font-family: ${FontNunitoBold};
              }
            }
          }
        }
      }
    }
    .search__result__404 {
      display: -webkit-box;
      display: -ms-flexbox;
      /* display: flex; */
      display: block;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      /* justify-content: space-between; */
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      padding: 16px;
      border-right: 8px solid transparent;
      border-bottom: 1px solid #ddd;
      text-transform: none;
      -webkit-transition: all .2s;
      transition: all .2s;
      color: #4a4a4a;
      max-height: 300px;
      .search__result__message {
        /* margin-bottom: 10px; */
        /* font-weight: bold; */
        /* text-transform: capitalize; */
        /* font-size: 10px; */
      }
    }
  }
  @media only screen and (max-device-width:1280px){
    .form-control{
      /* width: 400px; */
      width: 420px;
    }
    .search__result__container {
      width: 420px;
    }
  }
  @media only screen and (min-width:1280px){
    .form-control{
      width: 570px;
    }
    .search__result__container {
      width: 570px;
    }
  }
  @media only screen and (min-width:1440px){
    .form-control{
      width: 700px;
    }
    .search__result__container {
      width: 700px;
    }
  }
  @media only screen and (min-width:1440px){
    .form-control{
      width: 700px;
    }
    .search__result__container {
      width: 700px;
    }
  }
`;

const Asearch = styled.label`
  ${"" /* margin-left: 30%; */}
  cursor: pointer;
  &:hover {
    transition: 0.2s ease;
    ${"" /* ${SearchIcon} {
      transform: scale(1.1);
      -webkit-transition: all .2s;
      transition: all .2s;
      float: left;
      clerfix: both;
    } */}
  }
  div {
    background-color: #4a4a4a;
    .form-control {
      height: 40px;
      border-radius: 0;
      width: 500px;
      padding-left: 2rem;
      font-size: 0.75rem;
      border: 1px solid #979797;
      &:focus {
        border-color: #979797;
        box-shadow: 0 0 0 0 #979797;
      }
    }
    img {
      position: absolute;
      top: 25px;
      width: 20px;
      margin-left: 0.5rem;
    }
    .search__result__container {
      color: #fff;
      text-align: left;
      position: absolute;
      overflow-y: scroll;
      -webkit-box-shadow: 0 4px 3px 0 hsla(0, 0%, 72.2%, 0.6);
      box-shadow: 0 4px 3px 0 hsla(0, 0%, 72.2%, 0.6);
      /* width: 500px; */
      width: 770px;
      .search__result__inner {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding: 16px;
        border-right: 8px solid transparent;
        /* border-bottom: 1px solid #ddd; */
        text-transform: none;
        -webkit-transition: all 0.2s;
        transition: all 0.2s;
        /* background-color: #fff; */
      }
    }
  }
`;

const SearchIcon = styled.img`
  position: relative;
  max-width: 30px;
  margin: 5px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const ContainerIcon = styled.div`
  position: relative;
  width: 100%;
  ${"" /* height: 95px; */}
  height: 70px;
  overflow: hidden;
  display: flex;
  //border: 1px solid #000;
  justify-content: ${(props) => (props.right ? "flex-end" : "flex-start")};
  align-items: center;
  margin: 0 auto;
  padding-right: ${(props) => (props.right ? "1rem" : "0rem")};
  padding-left: ${(props) => (props.right ? "0rem" : "1rem")};
  @media only screen and (max-width: 1024px) {
    padding-right: 0;
  }
  @media only screen and (max-width: 768px) {
    padding-right: 0;
  }
`;

// <----- SubNav ---->
const WrapSubNavUL = styled.ul`
  display: ${(props) => (props.isRenderSubNav ? "grid" : "none")};
  grid-template-columns: 10rem 10rem 12rem;
  grid-gap: 10px;
  // grid-template-columns: repeat(3, 100px);
  grid-template-rows: repeat(8, 28px);
  grid-auto-flow: column;
  position: absolute;
  background-color: #f5f5f5;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: -999;
  width: 100%;
  min-height: 340px;
  max-height: 340px;
  left: 0;
  opacity: 0.95;
  -webkit-transition: 1s ease;
  transition: all 0.4s;
  column-count: 3;
  column-gap: 2;
  padding: 1.2rem 6rem;
`;

const SubNavLI = styled.li`
  color: black;
  pointer: cursor;
  ${"" /* padding: 1rem 0rem; */}
  padding: 0rem;
  text-decoration: none;
  display: block;
  text-align: left;
  cursor: pointer;
  &:hover {
    color: #179953 !important;
    font-family: ${FontNunitoSemiBold};
  }
`;
const ButtonLink = styled.a`
  background: none;
  color: #4a4a4a;
  font-size: 1.125rem;
  font-family: ${FontNunitoSemiBold};
  text-decoration: none;
  border: none;
  &:focus,
  &:hover,
  &:active {
    outline: none;
    text-decoration: none;
  }
  &.isActive {
    border-bottom: 2px solid #4a4a4a;
  }
  padding: ${(props) =>
    props.withoutPaddingTop ? "0 1rem 1rem 1rem" : "2.25rem 1rem 1rem 1rem"};
  ${"" /* padding: 2.25rem 1rem 1rem 1rem; */}
`;

const ContainerButtonCategory = styled(Row)`
  justify-content: center;
  width: 100%;
  &.container-category-kickave__desktop-hidden {
    display: none;
  }
`;

const Button = styled.button`
  background: none;
  color: #4a4a4a;
  font-size: 1.125rem;
  font-family: ${FontNunitoSemiBold};
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &.isActive {
    border-bottom: 2px solid #4a4a4a;
  }
  padding: ${(props) =>
    props.withPaddingTop ? "0 1rem 1rem 1rem" : "2.25rem 1rem 1rem 1rem"};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
`;

const ButtonCategory = styled(ButtonLink)`
  font-size: 0.75rem;
  font-family: ${FontNunitoSemiBold};
  padding: 0 0.25rem 0.25rem 0.25rem;
`;

export {
  KickNavbarV3Wrapper,
  KickNavbarV3Overlay,
  KickNavbarV3WrapperInner,
  KickNavbarV3WrapperInnerTop,
  KickNavbarV3WrapperInnerBottom,
  InnerBottomUL,
  InnerBottomLI,
  KickAvenueWrappIcon,
  KickAvenueBrandIcon,
  KickAvenueBrand,
  InnerBottomItemA,
  SearchIcon,
  Asearch,
  ContainerIcon,
  WrapSubNavUL,
  SubNavLI,
  A,
  LinkTo,
  Button,
  ButtonLink,
  Anchor,
  ButtonCategory,
  SearchFormWrapper,
  ContainerButtonCategory,
  CountDownSecretSanta,
  SecretSantaLeft,
  SecretSantaMid,
  SecretSantaRight,
  InnerBottomBCA
};
